import React from 'react';

import SelectorGrid from "../../../../form/SelectorGrid/SelectorGrid";
import TextInput from "../../../../form/TextInput";
import Button from "../../../../form/Button";
import {CurrencyFormatter} from "../../../../../utils/formatters";
import debounce from "../../../../../utils/debounce";

class WholeSalePoolList extends React.Component {
    state = {
        searchTerm: ""
    }
    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    setSearchValue = debounce((field, value) => {
        this.setState({searchTerm: value});
    }, 300);

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TextInput
                            name="searchTerm"
                            value={this.state.searchTerm}
                            saveChanges={this.setSearchValue}
                            label="Keresés"
                        />
                    </div>
                </div>
                <SelectorGrid
                    ref={(el) => this.list = el}
                    component="OperationProductPoolItem"
                    {...props}
                    reqparams={{search: this.state.searchTerm}}
                    columns={{
                        "cover_image.url": {
                            header: 'Borító',
                            width: 2,
                            sortable,
                            filterable,
                            renderer: (value, rowData) => {
                                if (value) {
                                    return <img alt={rowData.displayname} src={value} style={{maxWidth: '100px', maxHeight: '100px'}}/>;
                                }
                                return null;
                            }
                        },
                        displayname: {
                            header: 'Név',
                            width: 4,
                            filterable,
                            sortable
                        },
                        listprice: {
                            header: 'Lista ár',
                            width: 2,
                            filterable,
                            sortable,
                            renderer: CurrencyFormatter
                        },
                        "tradename.name": {
                            header: 'Kiadó',
                            width: 2,
                            filterable,
                            sortable
                        },
                        "actions": {
                            header: "Mennyiség",
                            width: 2,
                            renderer: (value, rowData) =>
                                <TextInput
                                    label={false}
                                />

                        },
                        "cart-actions": {
                            header: "Kosár",
                            width: 'cell-button',
                            renderer: (value, rowData) =>
                                <Button
                                    size="xs"
                                    color="default"
                                    icon={{lib: "fas", name: "shopping-cart"}}
                                />

                        }
                    }}
                />
            </>
        );
    }
}

export default WholeSalePoolList;
